import '../Assets/Styles/register.css';
import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Link,useNavigate} from 'react-router-dom';

import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

// Load Actions
import * as AppActions from '../Store/Actions/App';
import { FaLongArrowAltRight } from 'react-icons/fa';

// UpdateService dialog component
const SelectAgencyView = (props) => {

// set vars from props
const {
	dialog,
	setDialog,
	scrollBlock,
	setCurrentAgency,
	currentAgency,
	setAlert,
	setAlertTitle,
	setAlertBody,
	retrieveSelectableCompanies,
	retrieveSelectableCompanyUsers
} = props;		

const [agency, setAgency] = React.useState('');
const [agencyEmployee, setAgencyEmployee] = React.useState('');
const [loading, setLoading] = React.useState(true); 
const [saving, setSaving] = React.useState(false); 
const [selectedAgency, setSelectedAgency] = React.useState(''); 
const [selectedEmployee, setSelectedEmployee] = React.useState(''); 
const [agencyItems, setAgencyItems] = React.useState([]);
const [employeeItems, setEmployeeItems] = React.useState([]);


var navigate = useNavigate();


const applyAgencyAction = () => {
	if (!selectedAgency.code) {
		setAlert(true);
		setAlertTitle("Ops! Ocorreu um problema!");
		setAlertBody("Você precisa selecionar uma agência para confirmar!");
		return;
	}

	if (!selectedEmployee.code) {
		setAlert(true);
		setAlertTitle("Ops! Ocorreu um problema!");
		setAlertBody("Você precisa selecionar um funcionário da agência selecionada para confirmar!");
		return;
	}

	confirmDialog({
		message: 'Ao confirmar uma nova agência um novo processo de reserva será iniciado. Se vocês está no meio de um processo de reserva, todas as informações preenchidas até agora serão perdidas. Deseja continuar?',
		header: 'Confirma mudança de agência?',
		icon: 'pi pi-exclamation-triangle',
		acceptLabel: "Sim, continuar",
		rejectLabel: "Cancelar",
		accept: () => finalizeAgencyAction(),
		reject: () => {},
		contentStyle: { maxWidth: "30vw", width: "30vw" }
	});
};

const finalizeAgencyAction = () => {
	setSaving(true);

	setTimeout(function () {

		const currentAgencyObj = {
			agencyCode: selectedAgency.code,
			agencyName: selectedAgency.name,
			employeeName: selectedEmployee.name,
			employeeCode: selectedEmployee.code,
		};

		setCurrentAgency(currentAgencyObj);
		setDialog('selectAgencyModal', false);
		setSaving(false);

		navigate("/order");

	}, 500);
};

	
const close = ()=> {
	// setValidateRegistry(false);
	setDialog('selectAgencyModal',false);
	
	// Reset Fields
	setSelectedAgency("");	
	setSelectedEmployee("");
	setAgencyItems([]);
	setEmployeeItems([]);
	
		
	setTimeout(function() {
		if (scrollBlock) {
			document.body.classList.add('p-overflow-hidden');	
		} // end if 
	},300);
}	
	
const accept = () => {
	close();
}

const reject = () => {
	
}

const confirm1 = () => {
	confirmDialog({
		message: 'O seu email é a principal forma de comunicação entre a Dream4 e você. Por isso é importante que valide o mesmo. Mesmo que seu cadastro seja aprovado, só será possível acessar a plataforma após validar o email informado.',
		header: 'Tem certeza que quer validar depois?',
		icon: 'pi pi-exclamation-triangle',
		accept,
		reject,
		acceptLabel:"Sim, tenho certeza!",
		rejectLabel:"Fechar",
		contentStyle:{maxWidth:"30vw",width:"30vw"}
	});
};
	
const footerContent = (
	<div className="modalFooterButtonsEnd">
		
			<div className="modalFooterButtonsRight">
				<ConfirmDialog />
				<Button label="Fechar" disabled={saving} icon="pi pi-times" className="p-button-text" onClick={() => close()} />
				<Button label="Confirmar" icon="pi pi-check" loading={saving} onClick={() => applyAgencyAction()} />
			</div>		
		
	</div>
);		

// Execute when dialog opens
React.useEffect(() => {

	setSaving(false);
	
  // Runs when UNMOUNT component
  return () => {
    
	setSaving(false);
	
	// Reset Fields
	setSelectedAgency("");	
	setSelectedEmployee("");
	setAgencyItems([]);
	setEmployeeItems([]);
			
	
  };	
			
},[]);


React.useEffect(() => {

	if (dialog.target === 'selectAgencyModal' && dialog.status) {

		setSelectedAgency("");	
		setSelectedEmployee("");
		setAgencyItems([]);
		setEmployeeItems([]);
	
		// Busca agências
		props.retrieveSelectableCompanies().then((result) => {
			if (result.success) {
				const items = result.data;
				setAgencyItems(items);

				// ✅ Se já havia uma agência ativa, selecionar automaticamente
				if (currentAgency && currentAgency.agencyCode) {
					const preSelectedAgency = items.find(ag => ag.code === currentAgency.agencyCode);
					if (preSelectedAgency) {
						setSelectedAgency(preSelectedAgency);
					}
				}
			} else {
				setAgencyItems([]);
				setAlert(true);
				setAlertTitle("Erro");
				setAlertBody("Não foi possível carregar a lista de agências. Tente novamente.");
			}
		});


	}

}, [dialog]);

React.useEffect(() => {

	if (selectedAgency && selectedAgency.code) {
		setSelectedEmployee("");
		setEmployeeItems([]);

		props.retrieveSelectableCompanyUsers(selectedAgency.code).then((result) => {
			if (result.success) {
				setEmployeeItems(result.data);

				// ✅ Se já havia um funcionário salvo, selecionar
				if (currentAgency && currentAgency.employeeCode) {
					const preSelectedEmployee = result.data.find(emp => emp.code === currentAgency.employeeCode);
					if (preSelectedEmployee) {
						setSelectedEmployee(preSelectedEmployee);
						return;
					}
				}

				// ✅ Se só há um funcionário, seleciona automaticamente
				if (result.data.length === 1) {
					setSelectedEmployee(result.data[0]);
				}
			} else {
				setEmployeeItems([]);
				setAlert(true);
				setAlertTitle("Erro");
				setAlertBody("Não foi possível carregar os funcionários da agência selecionada.");
			}
		});
	}


}, [selectedAgency]);

	
	return (
	<>
			<Dialog header="Selecione a agência ativa" closeOnEscape={false} draggable={false} closable={false} visible={dialog.target == 'selectAgencyModal' && dialog.status} style={{ width: '35vw' }} breakpoints={{ '1400px': '45vw','960px': '50vw', '641px': '100vw' }} onHide={() => close()} footer={footerContent} >
			
			
			<Box
				  sx={{
					width: "100%",
				  }}
				  className="terms"
				>
				
					<div className="termsModalIntro"> Selecione a agência e o funcionário para realizar compras como se fosse a agência. <br /><br /> <small> O pagamento do pedido deverá ser feito diretamente pela agência após a reserva. </small> </div>
				
					<Divider />
					
					<span className="p-float-label" style={{marginTop:"1.975rem"}}>
						<Dropdown
							id="agencySelector"
							disabled={saving}
							value={selectedAgency}
							onChange={(e) => setSelectedAgency(e.value)}
							options={agencyItems}
							optionLabel="name"
							placeholder="Selecione"
							className="w100"
							filter={true}
							filterLocale="pt-BR"
							emptyFilterMessage="Nenhum resultado"
							emptyMessage="Nenhum resultado"
							itemTemplate={(option) => (
								<div className="dropdown-agency-template">
								<div style={{ fontWeight: 500 }}>{option.name}</div>
								{option.tradingName && (
									<div style={{ fontSize: '0.75rem', color: '#777' }}>Nome Fantasia: {option.tradingName}</div>
								)}
								</div>
							)}
						/>
						<label htmlFor="agencySelector">Agência</label>
					</span>	
					
					<span className="p-float-label" style={{marginTop:"1.975rem"}}>
						<Dropdown id="employeeSelector" disabled={!selectedAgency} value={selectedEmployee} onChange={(e) => setSelectedEmployee(e.value)} options={employeeItems} optionLabel="name" placeholder="Selecione" className="w100" filter={true} filterLocale="pt-BR" emptyFilterMessage="Nenhum resultado" emptyMessage="Nenhum resultado" ></Dropdown>
						<label htmlFor="employeeSelector">Funcionário</label>
					</span>						
					 
			</Box> 
			
						
            </Dialog>	
	</>	
	);
	
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  currentAgency:store.appReducer.currentAgency
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions }, dispatch);

export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(SelectAgencyView);	
